import React, { Component } from 'react';

import EpoExternallocationModel from './EpoExternallocationModel';

import { Select } from 'antd';
const Option = Select.Option;

class EpoExternallocationSelect extends Component {

  state = {
    children: []
  }

  componentWillMount() {            
    EpoExternallocationModel.getAll(true)
    .then(data => {     
      var children = [];   
      data.map((child, key) => {
        return children.push(<Option key={child.guid}>{child.code} - {child.name}</Option>);
      });
      this.setState({
        children: children
      });
    });
  }

  render() {    
    return (    
      <Select
        size="default"
        showSearch
        placeholder={this.props.placeholder ? this.props.placeholder : 'Zvolte externí lokalitu'}
        optionFilterProp="children"
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} 
        onChange={(value) => { this.props.onChange(value) }}
        style={this.props.style ? this.props.style : {}} 
        {...this.props}>
          {this.state.children}
      </Select>
    );
  }
}

export default EpoExternallocationSelect;


// WEBPACK FOOTER //
// ./src/components/EpoExternallocationSelect.js